
















import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {multiNil, nil} from '@/common';
import {xor} from 'lodash';

@Component({
    components: {
    },
})
export default class ImageGrid extends Vue {
    @Prop({default: 150})
    public size!: number;
    @Prop({default: () => []})
    public images!: any[];
    @Prop({default: 9})
    public imagesPerPage!: number;
    @Prop({default: false})
    public selectable!: boolean;
    @Prop({default: false})
    public removable!: boolean;
    @Prop({default: true})
    public multiple!: boolean;
    @Prop({default: () => []})
    public selection!: any[] | any;
    @Watch('innerSelection')
    public onSelectionChanged(value: any[] | any, oldValue: any[] | any) {
        this.$emit('update:selection', value);
    }

    public imagePage: number = 1;
    public innerSelection: any | any[] = [];
    public loadMore() {
        this.imagePage++;
    }
    public isSelected(image) {
        if (!this.multiple && nil(this.selection)) {
            return false;
        }
        return this.multiple ? this.selection.map((x) => x._id).indexOf(image._id) > -1 : this.selection._id === image._id;
    }
    public get showLoadMore() {
        const imageAt = this.imagesPerPage * this.imagePage;
        return this.images.length > imageAt;
    }
    public get imagesLoaded() {
        if (nil(this.images) || this.images.length === 0) {
            return [];
        }
        try {
            return this.images.slice(0, (this.imagePage * this.imagesPerPage));
        } catch (e) {
            return [];
        }
    }
    public onTileClicked(image) {
        if (!this.selectable) { return; }
        if (this.multiple) {
            if (this.selection.map((x) => x._id).indexOf(image._id) > -1) {
                this.onRemoveImage(image);
            } else {
                this.innerSelection = [...this.selection, image];
            }
        } else {
            this.innerSelection = (multiNil(this, 'selection._id') || this.selection._id !== image._id) ? image : null;
        }
    }
    public onRemoveImage(image) {
        this.$emit('onRemove', image);
        this.innerSelection = this.selection.filter((x) => x._id !== image._id);
    }
}
